import _ from "lodash";
import { ContentBlockFormType, TaxesFormType } from "components/template_editor/context";

/**
 * Calculates tax amounts by rate from total taxes and content blocks.
 * Handles net/gross price conversion based on isPricesNet flag.
 */
export function getTaxAmountByRate(totalTaxes: TaxesFormType[], contentBlocks: ContentBlockFormType[], isPricesNet: boolean) {
  return _.orderBy(totalTaxes, [t => t.rate], 'asc').map((tax, index) => {
    let netAmount = 0;
    let grossAmount = 0;

    const componentAmount = contentBlocks.reduce((s, cb) => {
      return (
        s +
        (cb.lineItems || []).reduce((s, li) => {
          return (
            s +
            li.components.reduce((s, c) => {
              if (c.taxTypeId === tax.taxTypeId) {
                return s + li.count * c.price;
              }
              return s;
            }, 0)
          );
        }, 0)
      );
    }, 0);

    if (isPricesNet) {
      netAmount = componentAmount;
      grossAmount = netAmount + tax.price;
    } else {
      grossAmount = componentAmount;
      netAmount = grossAmount - tax.price;
    }

    return {
      ...tax,
      netAmount,
      grossAmount,
    };
  });
}
